import React from 'react';
import { X } from 'lucide-react';

interface RecipientTagProps {
  name: string;
  onRemove: () => void;
}

export const RecipientTag: React.FC<RecipientTagProps> = React.memo(({ name, onRemove }) => {
  const handleRemoveClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove();
  };

  return (
    <div className="inline-flex items-center px-3 py-1 m-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300">
      <span className="mr-1">{name}</span>
      <button
        type="button"
        onClick={handleRemoveClick}
        className="ml-1 p-1 rounded-full hover:bg-blue-200 dark:hover:bg-blue-800 transition-colors"
        aria-label={`Remove ${name}`}
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
});

RecipientTag.displayName = 'RecipientTag';
